import { Params, useParams } from "react-router-dom";
import { isTaskPromoTagPhotos } from "tm-shared/utils";

import { useAppSelector } from "@/hooks/redux";
import NotFound from "@/routes/Pages/NotFound";

import { PromoTagPhotosPage } from "./PromoTagPhotosPage";

interface PromoTagPhotosParams extends Params {
    marketId: string;
    taskId: string;
}

const PromoTagPhotos = () => {
    const { marketId, taskId } = useParams<PromoTagPhotosParams>();
    const { markets, tasks } = useAppSelector((s) => s.work);

    const safeMarketId = marketId ?? "";
    const safeTaskId = taskId ?? "";

    const currentMarket = markets?.[safeMarketId];
    const currentTask = tasks?.[safeMarketId]?.[safeTaskId];

    if (!currentMarket || !currentTask || !isTaskPromoTagPhotos(currentTask)) {
        return <NotFound />;
    }

    return <PromoTagPhotosPage task={currentTask} market={currentMarket} />;
};

export default PromoTagPhotos;
